module.exports = __webpack_public_path__ + "fwm_h5/img/ybqlogo.9695b491.png";